import { useState } from 'react';
import { useDidMount } from 'rooks';
import { Bell } from 'lucide-react';

import NavItem from './NavItem';
import { getUnseenNewsCount } from '@/app/product/_helpers';

import { useSelf } from '@/data/user';

// The "Updates" rail link. Owns the unseen-news indicator logic so the top-level
// Navigation component stays purely structural.
const ProductLink = () => {
  const [unseenNewsCount, setUnseenNewsCount] = useState(0);
  const self = useSelf(false);

  useDidMount(() => {
    setUnseenNewsCount(getUnseenNewsCount(self.data));
  });

  const handleHideNews = () => {
    setUnseenNewsCount(0);
  };

  return <NavItem to="/product" label="Updates" icon={Bell} testId="nav-link-product" indicatorCount={unseenNewsCount} onClick={handleHideNews} />;
};

export default ProductLink;
